
// This loads the polyfill chunk if necessary
export function provideResizeObserver() {
  if (window.ResizeObserver) {
    return Promise.resolve({
      ResizeObserver
    });
  }
  return import('@/js/vendor/polyfill-inert-chunk');
}
